module.exports = __webpack_public_path__ + "34736292/img/copy-icon.408fdb2d.svg";